export const FOCUSABLE_ELEMENT_SELECTORS =
  'button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), audio[controls], video[controls], [contenteditable]:not([contenteditable="false"])'
